/**
 * The "AI code review" guide and the list of AI code review tools. next.config reaches this module
 * through merged-blog-posts, so it stays free of imports.
 */

export const AI_CODE_REVIEW_PATH = '/ai-code-review';
export const BEST_AI_CODE_REVIEW_TOOLS_PATH = '/best-ai-code-review-tools';
